import { Flex } from '@chakra-ui/react';
import React from 'react';
import { HiMiniPlus } from 'react-icons/hi2';
type AddButtonType = {
  onClick?: () => void;
  isDisable?: boolean;
  e2eTitle?: string;
};
/**
 * @useFor the small "+"-glyph add button shown next to list /
 *   section headers — opens the create flow for the item type the
 *   section represents.
 *
 *   Examples in-tree: People list → add person; Roles → add role;
 *   `<SectionCard>` headers when an inline "add" action is needed.
 *
 *   For full-width "Create X" actions in a page header use
 *   `<Button>` with a primary variant instead. AddButton is
 *   specifically the compact 25×25 trigger pattern.
 */
const AddButton = (props: AddButtonType) => {
  const { onClick, isDisable = false, e2eTitle } = props;
  return (
    <Flex
      data-e2e={e2eTitle}
      height={'25px'}
      w={'25px'}
      justifyContent={'center'}
      alignItems={'center'}
      fontSize={'16px'}
      bg={'defaultSafety.primary'}
      borderRadius={'md'}
      opacity={isDisable ? 0.8 : 1}
      color={'#fff'}
      cursor={isDisable ? 'not-allowed' : 'pointer'}
      onClick={isDisable ? undefined : onClick}
    >
      <HiMiniPlus />
    </Flex>
  );
};

export default AddButton;
